import GraphTask from 'models/task/GraphTask';

/**
 * Class representing a map task.
 * @extends Mission
 */
export default class MapTask extends GraphTask {}
